import { LitElement, html, css, unsafeCSS } from 'lit';
import styles from './sticky-bars.scss?inline';

export default class SotbitStickyBar extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        observerEntitySelector: {
            type: String,
            attribute: 'observer-entity-selector',
        },
    };

    constructor() {
        super();

        this.observerEntitySelector = '';
        this.observerEntity = null;
        this.intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                this.toggleAttribute('hide', entry.isIntersecting);
            });
        });
    }

    connectedCallback() {
        super.connectedCallback();
        this.initObserver();

        this.setAttribute('connected', '');
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.intersectionObserver.disconnect();
    }

    initObserver() {
        this.observerEntity = document.querySelector(this.observerEntitySelector);
        this.intersectionObserver.disconnect();
        if (this.observerEntity) {
            this.intersectionObserver.observe(this.observerEntity);
        }
    }

    handleSlotChange(e) {
        this.parseOptionsFromSlot(e);
    }

    render() {
        return html`
            <div class="content">
                <slot name="content"></slot>
            </div>
            <slot name="button"></slot>
        `;
    }
}
